import * as React from "react";
import { usePerformAction } from "react-remote-data-hooks";
import api from "../../../../api";
import {
  LeadAssignmentSettings,
  convertPascalCaseToWords,
} from "../../../../core";
import { useAppSettings } from "../../../../core/hooks/useAppSettings";
import UpdateForm from "./UpdateForm";

interface IQuotationSettingsProps {
  data?: LeadAssignmentSettings;
  reload?: () => void;
}

const LeadAssignmentTab: React.FunctionComponent<IQuotationSettingsProps> = (
  props
) => {
  const appSettings = useAppSettings(api.settings);
  const [editModalOpen, setEditModalOpen] = React.useState(false);

  const {
    performAction: update,
    error: updateError,
    isPerforming: updating,
  } = usePerformAction(
    (data: LeadAssignmentSettings) =>
      api.settings.updateLeadAssignmentSettings({
        ...data,
        noOfDaysToTakeCRMAgentForAutoAssign: data.noOfDaysToTakeCRMAgentForAutoAssign
          ? Number(data.noOfDaysToTakeCRMAgentForAutoAssign)
          : undefined,
      }),
    () => {
      props.reload?.();
      setEditModalOpen(false);
      appSettings.reload();
    }
  );

  return (
    <>
      <div className="col-lg-4 col-md-6 col-12 border-right">
        <div className="d-flex align-items-center py-3">
          <div className="col">
            <h4 className="mb-0 font-weight-semibold">Lead Distribution</h4>
          </div>
          <div className="col-auto text-right">
            <button
              className="btn btn-link font-normal font-weight-semibold px-2 py-2 d-inline-flex align-items-center"
              onClick={() => setEditModalOpen(true)}
            >
              <i className="icon-edit mr-1 font-xs"></i> Edit
            </button>
          </div>
        </div>
        <div className="grid-table grid-table--sm border-top">
          <table>
            <thead>
              <tr>
                <th>
                  <span className="d-inline-flex align-items-center">
                    Assigned User
                  </span>
                </th>
                <th>
                  <span className="d-inline-flex align-items-center">
                    User Types
                  </span>
                </th>
              </tr>
            </thead>
            <tbody>
            <tr>
                <td>Lead Manager</td>
                <td>
                  {props.data?.leadManagerTypes?.map((crm, index) => {
                    return (
                      <>
                        {convertPascalCaseToWords(crm === "CallCenterExecutive" ?
                          "SupportExecutive" : crm === "Agent" ?
                            "TransactionManager" : crm)}
                        {index !==
                          (props.data?.leadManagerTypes?.length || 1) - 1 && (
                            <>, </>
                          )}
                      </>
                    );
                  })}
                </td>
              </tr>
              <tr>
                <td>Group Manager</td>
                <td>
                  {props.data?.groupManagerTypes?.map((crm, index) => {
                    return (
                      <>
                        {convertPascalCaseToWords(crm === "CallCenterExecutive" ?
                          "SupportExecutive" : crm === "Agent" ?
                            "TransactionManager" : crm)}
                        {index !==
                          (props.data?.groupManagerTypes?.length || 1) - 1 && (
                            <>, </>
                          )}
                      </>
                    );
                  })}
                </td>
              </tr>
              <tr>
                <td>Telecaller</td>
                <td>
                  {props.data?.teleCallerTypes?.map((crm, index) => {
                    return (
                      <>
                        {convertPascalCaseToWords(crm === "CallCenterExecutive" ?
                          "SupportExecutive" : crm === "Agent" ?
                            "TransactionManager" : crm)}
                        {index !==
                          (props.data?.teleCallerTypes?.length || 1) - 1 && (
                            <>, </>
                          )}
                      </>
                    );
                  })}
                </td>
              </tr>
              <tr>
                <td>Support Executive</td>
                <td>
                  {props.data?.crmAgentTypes?.map((crm, index) => {
                    return (
                      <>
                        {convertPascalCaseToWords(crm === "CallCenterExecutive" ?
                          "SupportExecutive" : crm === "Agent" ?
                            "TransactionManager" : crm)}
                        {index !==
                          (props.data?.crmAgentTypes?.length || 1) - 1 && (
                            <>, </>
                          )}
                      </>
                    );
                  })}
                </td>
              </tr>
              <tr>
                <td>Transaction Manager</td>
                <td>
                  {props.data?.salesPersonTypes?.map((crm, index) => {
                    return (
                      <>
                        {convertPascalCaseToWords(crm === "CallCenterExecutive" ?
                          "SupportExecutive" : crm === "Agent" ?
                            "TransactionManager" : crm)}
                        {index !==
                          (props.data?.salesPersonTypes?.length || 1) - 1 && (
                            <>, </>
                          )}
                      </>
                    );
                  })}
                </td>
              </tr>
              <tr>
                <td>Lead Assignee Head</td>
                <td>
                  {props.data?.leadAssigneeHeadTypes?.map((crm, index) => {
                    return (
                      <>
                        {convertPascalCaseToWords(crm === "CallCenterExecutive" ?
                          "SupportExecutive" : crm === "Agent" ?
                            "TransactionManager" : crm)}
                        {index !==
                          (props.data?.leadAssigneeHeadTypes?.length || 1) - 1 && (
                            <>, </>
                          )}
                      </>
                    );
                  })}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div className="col-lg col-md-6 col-12 p-2 setting-detail-block left-0 top-0 bg-white w-100 h-100 zIndex-1">
        {editModalOpen && (
          <>
            <div className="text-right d-md-none">
              <i className="icon-close"></i>
            </div>
            <UpdateForm
              onSubmit={(formData) => update(formData)}
              isSubmitting={updating}
              error={updateError?.message}
              data={props.data}
              onCancel={() => setEditModalOpen(false)}
            ></UpdateForm>
          </>
        )}
      </div>
    </>
  );
};

export default LeadAssignmentTab;
